<template>
	<div>
		<div class="selector !relative ms-2" :class="{disabled : disabled}" @click="toggleList">
			<span class="token-img-outer">
				<img class="token-img w-fit max-w-7"
						alt=""
						loading="lazy"
						height="32px" width="32px"
						:src="tokenImageSrc">
				<sup v-if="token?.verified"><i class="fa fa-star" title="Verified token"></i></sup>
			</span>
			<h4 class="d-inline-block ms-2 mb-0 token-name">{{ tokenSymbol || 'SELECT' }}</h4>
			<i v-if="!disabled" class="fa fa-angle-down ms-1"></i>
		</div>
		<portal to="body">
			<TokenSelectList v-if="showList" @close="toggleList" @select="onTokenChange"></TokenSelectList>
		</portal>
	</div>
</template>

<script>
import TokenSelectList from "@/components/token/TokenSelectList.vue";

export default {
	name: "TokenPicker",
	components: {TokenSelectList},
	props: {
		token: {
			type: Object,
			required: true
		},
		disabled: {
			type: Boolean,
			default() {
				return false
			}
		},
	},
	data() {
		return {
			showList: false,
			metadata: {
				//
			}
		}
	},
	watch: {
		symCheck: function () {
			this.getData()
		},
	},
	computed: {
		tokenImageSrc: function () {
			return this.token?.image || this.metadata?.image || `https://api.degencdn.com/v1/tokens/${this.token.address}/image.jpg`
		},
		tokenSymbol: function () {
			return this.metadata?.symbol?.toUpperCase() || this.token?.symbol?.toUpperCase()
		},
		symCheck: function () {
			return this.token?.image
		}
	},
	methods: {
		toggleList: function () {
			if (this.disabled)
				return

			this.showList = !this.showList
		},
		onTokenChange: function (token) {
			this.$emit('tokenChange', token)
			this.showList = false
		},
		getData: async function () {
			if (this.$store.state.cache.tokenMap[this.token?.address]?.image)
				return this.$store.state.cache.tokenMap[this.token?.address]
			try {
				const resp = await fetch(`https://api.degencdn.com/v1/tokens/${this.token?.address}`)
				this.metadata = await resp.json()
				this.$store.commit('cache/set_metadata', {address: this.token?.address, metadata: this.metadata})
			} catch (e) {
				this.metadata = {
					name: "Unknown",
					symbol: "Unknown",
					image: null
				}
			}

		},
	},
	mounted() {
		if (!this.$store.state.cache.tokenMap[this.token?.address]?.image)
			this.getData()
	}
}
</script>

<style scoped>

.selector {
	background: rgba(255, 255, 255, 0.2);
	padding: 0.25rem 0.5rem;
	border-radius: 6px;
	width: fit-content;
	cursor: pointer;
	transition: background-color 0.3s linear;

	display: flex;
	flex-direction: row;
	align-items: center;
}

.selector.disabled {
	background: rgba(255, 255, 255, 0);
	pointer-events: none;
}

.token-img {
	border-radius: 66%;
}

.token-name {
	line-height: 32px;
}

.selector:hover:not(.disabled) {
	background: rgba(255, 255, 255, 0.4);
}


.token-img-outer {
	display: flex;
	position: relative;
}

sup {
	font-size: 0.5rem;
	color: var(--bs-primary);
}

sup {
	position: absolute;
	top: 0;
	right: -0.25rem;
}
</style>